import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/list_templates/agro_exporter_process/${agro_exporter_id}/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/list_templates/container/${agro_exporter_id}/${container_id}`
    );
  },
  fetchQualityTemplateMainReps(
    agro_exporter_id,
    agro_exporter_process_id,
    container_id
  ) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/list_templates/${agro_exporter_id}/${agro_exporter_process_id}/${container_id}`
    );
  },
  downloadRepXlsxSummary({
    agro_exporter_id,
    agro_exporter_process_id,
    container_id,
    template_id
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/list_templates/${agro_exporter_id}/${agro_exporter_process_id}/${container_id}/template_rep_xlsx_summary/${template_id}`,
      { responseType: "blob" }
    );
  },
  downloadRepXlsxDetailed({
    agro_exporter_id,
    agro_exporter_process_id,
    container_id,
    template_id
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/list_templates/${agro_exporter_id}/${agro_exporter_process_id}/${container_id}/template_rep_xlsx_detailed/${template_id}`,
      { responseType: "blob" }
    );
  }
};
